// frontend/src/store/slices/vacancySlice.ts

import { create } from 'zustand'

interface VacancyState {
  currentVacancy: any | null
  vacancies: any[]
  isLoading: boolean
  total: number
  filters: any

  // Actions
  setCurrentVacancy: (vacancy: any) => void
  setVacancies: (vacancies: any[]) => void
  setLoading: (isLoading: boolean) => void
  setTotal: (total: number) => void
  setFilters: (filters: any) => void
  clearCurrentVacancy: () => void
}

export const useVacancyStore = create<VacancyState>((set) => ({
  currentVacancy: null,
  vacancies: [],
  isLoading: false,
  total: 0,
  filters: {},

  setCurrentVacancy: (currentVacancy) => set({ currentVacancy }),
  setVacancies: (vacancies) => set({ vacancies }),
  setLoading: (isLoading) => set({ isLoading }),
  setTotal: (total) => set({ total }),
  setFilters: (filters) => set({ filters }),
  clearCurrentVacancy: () => set({ currentVacancy: null })
}))